module.exports = __webpack_public_path__ + "static/media/box-blue.78959b82.svg";